import React, {useEffect, useState,useCallback} from "react";
import {useTranslation} from "react-i18next";
import {getActionBtnText, goToLiveSession, pageTitle} from "../../helper/CommonFunctions";
import './scss/ProfileLiveSession.scss'
import LiveSessionCard from "../../component/LiveSessionCard/LiveSessionCard";
import AxiosServices from "../../networks/AxiosService";
import ApiUrlServices from "../../networks/ApiUrlServices";
import {toast} from "react-toastify";
import CustomPagination from "../../component/paginations/CustomPagination";
import SkeletonCourseCard from "../../component/Skeleton/SkeletonCourseCard";
import {useNavigate} from "react-router-dom";
import path from "../../routes/path";
import { useSelector } from "react-redux";
import useWebSocket, { ReadyState } from 'react-use-websocket';
import { ws_base_url } from "../../config/config";
import { userData } from "../../config/sessionKeys";

const StudentProfileLiveSession = (props) => {
    const { sendMessage, lastMessage, readyState, getWebSocket } = useWebSocket(
        ws_base_url,
        {
            share: true,
            onOpen: () => console.log('opened ws'),
        }
    );
    const [messageHistory, setMessageHistory] = useState([]);
    //ws states ends
    const  { t } = useTranslation();
    pageTitle(props.pageTitle)
    React.useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    const navigate = useNavigate();
    const [type, setType] = useState('')
    const urlParams = new URLSearchParams(window.location.search);
    const pageSize = parseInt(urlParams.get('page'));
    const [currentSessionPage, setCurrentSessionPage] = useState(pageSize);
    const [loading,setLoading] = useState(false)
    const [sessionList,setSessionList] = useState([]);
    const [totalSession, setTotalSession] = useState(0);
    const getSessionData = JSON.parse(localStorage.getItem(userData));
    const foundRole = useSelector((state)=>state.userReducer.currentRole);
    const [currentRole,setCurrentRole] = useState(foundRole);

    useEffect(() => {
        setCurrentRole(foundRole);
        if(foundRole==="Instructor"){
            navigate(path.instructor_live_sessions+"?page=1");
        }
    }, [foundRole]);

    const pageLimit = 6;

    // ws scope starts here
    const handleClickSendMessage = useCallback(() => sendMessage('Hello'), []);
    const connectionStatus = {
        [ReadyState.CONNECTING]: 'Connecting',
        [ReadyState.OPEN]: 'Open',
        [ReadyState.CLOSING]: 'Closing',
        [ReadyState.CLOSED]: 'Closed',
        [ReadyState.UNINSTANTIATED]: 'Uninstantiated',
    }[readyState];

    useEffect(() => {
        if (lastMessage !== null) {
            console.log('lastMessage',JSON.parse(lastMessage.data),'sessions',sessionList)
            const {data,session_status} = JSON.parse(lastMessage.data)
            if(session_status==='running'){
                const sessionExist = sessionList.find(item=>item.session_id===data.session_id)
                if(sessionExist){
                    setSessionList(sessionList.map((item)=>{
                        if(item.session_id===data.session_id) return {...item,meeting_status:data.meeting_status}
                        return item
                    }))
                }
            }
            else{
                setSessionList(sessionList.filter(item=>item.session_id!==data.session_id))
            }
            setMessageHistory((prev) => prev.concat(lastMessage));
        }
    }, [lastMessage, setMessageHistory]);
    // useEffect(() => {
    //     console.log('connection status',connectionStatus)
    // }, [connectionStatus]);

    // ws scope ends here

    useEffect(() => {
        setType(window.location.pathname.split('/')[3])
    }, [navigate])

    const onPageChange=()=>{
        if (type.length > 0) {
            getAllStudentSessionList();
        }
    }

    useEffect(() => {
        onPageChange()
    }, [type])
    

    const getAllStudentSessionList = () => {
        setLoading(true)
        const end_point = ApiUrlServices.GET_INVITED_SESSION_LIST()
        
        AxiosServices.get(end_point)
        .then(res => {
            console.log(res.data);
            setLoading(false)
            if(type==="student-running"){
                const temp=res.data.data.sessions.filter(item=>item.meeting_status==="running")
                setSessionList(res.data.data.sessions.filter(item=>item.meeting_status==="running"));
                setTotalSession(0)
            }
            else{
                setSessionList(res.data.data.sessions.filter(item=>item.meeting_status!=="running"));
                setTotalSession(res.data.data?.total)
            }
        })
        .catch(err => {
            console.log(err);
            toast.error(`${t('ALL_MESSAGE.something_went_wrong')}`)
            setLoading(false)
        })
    }

    const handleCardActionBtnClick=(event,session)=>{
        //calling appropriate action based on session's meeting status
        switch(session.meeting_status){
            case 'running':
                goToLiveSession(session.meeting_url,getSessionData.userId,getSessionData.idToken,getSessionData.refreshToken,getSessionData.name,getSessionData.myEmail,session.password,false,'_blank');
                break;
            case 'ended':
                // go to details page
                goToSessionDetailsPage(session.session_id)
                break;
            case 'not_started':
                // go to details page
                goToSessionDetailsPage(session.session_id)
                break;
            default:
                return
        }
    }

    const goToSessionDetailsPage = (session_id)=>{
        navigate(`${process.env.PUBLIC_URL}${path.instructor_live_session_details}?id=${session_id}`);
    }
    
    return(
        <div className={"active-live-section"}>
            <CustomPagination
                onPageChange={onPageChange}
                currentPage={currentSessionPage}
                setCurrentPage={setCurrentSessionPage}
                totalPage={Math.ceil(Number(totalSession) / pageLimit)}
            >
                {
                    loading ?
                        <div className="row mt-10">
                            <SkeletonCourseCard col={'col-xl-4 col-lg-6 col-md-6 mb-30'} quantity={pageLimit}/>
                        </div>
                        :
                        <div className={"row"}>
                            {sessionList.length>0?
                                <>
                                    {sessionList.map((item, idx)=>
                                        <div className="col-lg-4 col-md-6 mb-30" key={idx}>
                                            <LiveSessionCard
                                                data={item}
                                                edit={true}
                                                adminDetails={true}
                                                actionBtnText={getActionBtnText(item.meeting_status)}
                                                onActionBtnClick={(event,session)=>{handleCardActionBtnClick(event,session)}}
                                            />
                                        </div>
                                    )}
                                </>
                                :<div className={'col-12 text-center'}>No Data Found</div>}

                        </div>
                }
            </CustomPagination>
            
        </div>
    )
}
export default StudentProfileLiveSession;